import { ORGANIZATION_ID } from './organizationIDTypes';

export const fetchOrganizationId = orgID => {
    return {
        type: ORGANIZATION_ID,
        payload: orgID,
    }
}